import styled from '@mui/system/styled';

export const AssetFormCnt = styled('div')({});
